import { DishFirstDishCard } from 'src/shared/design-system/DishFirstDishCard';
import { DishFirstDishCardLandscape } from 'src/shared/design-system/DishFirstDishCard/DishFirstDishCardLandscape';
import styled from 'styled-components';
import { Spacing } from 'web-common/src/shared/styles';

export const DishCard = styled(DishFirstDishCard)``;

export const DishCardLandscape = styled(DishFirstDishCardLandscape)``;

export const DishCardHalfLandscape = styled(DishFirstDishCardLandscape)`
  width: calc(50% - (${Spacing.SINGLE_HALF} / 2));
`;
